import {useMemo} from 'react'
import {PendantSide} from '_app/types/product'
import {Element, useFindElementDimensionsQuery,} from '_app/types/configurator'
import RequestEnum from '../../../enums/RequestEnum/RequestEnum'

type RequiredDimensions = Required<
    Pick<Element, 'frontDimension' | 'backDimension'>
>;
const DEFAULT_DIMENSIONS: RequiredDimensions = {
    frontDimension: {height: 20, left: 40, top: 45, width: 20},
    backDimension: {height: 20, left: 40, top: 45, width: 20},
}

export const useDimensions = (
    sku: string | undefined,
    activeSide: PendantSide
) => {
    const {data} = useFindElementDimensionsQuery({
        skip: !sku,
        context: {clientName: RequestEnum.MICROSERVICE},
        variables: {
            filters: {sku},
        },
    })
    const dimensions = useMemo(() => {
        const {frontDimension, backDimension} = data?.findElements.items[0] || {}
        return Object.assign(
            {},
            DEFAULT_DIMENSIONS,
            frontDimension && {frontDimension},
            backDimension && {backDimension}
        )
    }, [data])

    return activeSide === 'front'
        ? dimensions.frontDimension
        : dimensions.backDimension
}
